<template>
  <div>
    <div ref="page-container" class="page-container">
      <div ref="top-container" class="top-container">
        <div class="left-menu" ref="navigation-drawer">
          <memlist-navigation-drawer
            :items="unlocked_sections.filter(s => s.hide_on_create ? !creating : true).map(s => ({ icon: s.icon, value: s.value, text: s.title }))"
            @click="on_drawer_item_click"
            :preselected="selected_item"
          />
          <!--<div v-if="local_item_status === 'DRAFT' || local_item_status === 'ARCHIVED'">
            <memlist-icon-button
              class="mr-2 mt-4 w-100"
              icon="fa fa-play"
              :text="text_publish"
              variant="success"
              @click="publish_clicked"
            />
            
          </div>
          <div v-else-if="local_item_status === 'ACTIVE'">
            <memlist-icon-button
              class="mr-2 mt-4 w-100"
              icon="fa fa-archive"
              :text="text_archive"
              variant="primary"
              @click="archive_clicked"
            />
          </div>-->
          
        </div>

        <!-- fill the rest of the width -->
        <div class="content flex-grow-1 flex-fill">


          <div v-if="selected_section_name == 'basic_info'">

            <memlist-card
              title=""
              class="mb-2 edit-template-container"
              ref="edit-template"
              id="edit-template"
            >
              <form class="mt-8" @submit.prevent="save_template">

                <m-row>
                  <m-col lg="6">
                    <memlist-text-input
                      class="mt-4"
                      id="input-template_id"
                      v-model="local_value.template_id"
                      type="text"
                      required
                      disabled
                      title="ID"
                      layout="vertical"
                      size="sm"
                      validation_type="TEXT"
                    />

                    <div v-if="local_value.template_id">
                      <p style="font-weight: 500;" class="mt-4">Länk till publik sida</p>
                      <a @click.prevent="goto_url_clicked" target="_blank" class="ml-4 mb-8 ml-url-link legacy-link d-inline-flex align-items-center text-decoration-none">
                        <span class="svg-icon svg-icon-md text-primary me-2">
                          <i class="fa fa-link color-primary"></i>
                        </span>
                        <span class="ml-4 text-primary">{{ template_public_url }}</span>
                      </a>

                    </div>
                    
                    
                    <memlist-text-input
                      class="mt-4"
                      id="input-group-1"
                      v-model="local_value.name"
                      :title="$t('TEMPLATE.NAME')"
                      layout="vertical"
                      size="sm"
                      required
                      validation_type="TEXT"
                      :state="valid_name_state"
                    />

                  </m-col>
                </m-row>
                
                <m-row class="mt-8">
                  
                  <m-col lg="6">

                    <memlist-checkbox
                      
                      v-model="local_value.is_system"
                      :text="$t('TEMPLATE.SYSTEM')"
                    />

                    <hr />

                    <memlist-checkbox
                      class="mt-4"
                      v-model="local_value.is_theme"
                      :text="$t('TEMPLATE.IS_THEME')"
                    />
                    <p class="mt-1" style="font-style: italic; color: #888888;">{{ $t('TEMPLATE.THEME_INFO') }}</p>
                  </m-col>
                </m-row>

                <div class="mt-4">
                            
                  <memlist-button v-if="source === 'sendout'" variant="success" class="ml-2" @click="backToSendout"
                    >{{$t('COMMON.BACK')}}</memlist-button>
                </div>
              
              </form>
              
            </memlist-card>

          </div>

          <div v-else-if="selected_section_name == 'designer'">
            <EmailTemplateEditor
              ref="emailTemplateEditor"
              :design="local_value.edit_html"
              @designSaved="on_template_design_saved"
              @auto_save="on_template_auto_save"
              @plaintextGenerated="on_plaintext_generated"
            />
          </div>
          <div v-else-if="selected_section_name == 'sender'">
            <memlist-card>
              <m-row class="mt-4">
                <m-col lg="6" style="padding-left: 0px;">
                  <memlist-text-input
                    class="mt-4"
                    id="from_name-group"
                    :title="$t('PAGES.SENDOUT.FROM_NAME')"
                    v-model="local_value.from_name"
                    :placeholder="$t('PAGES.SENDOUT.FROM_NAME')"
                  />

                  <memlist-text-input
                    class="mt-4"
                    id="subject-group"
                    :title="$t('PAGES.SENDOUT.SUBJECT')"
                    v-model="local_value.subject"
                    :placeholder="$t('PAGES.SENDOUT.SUBJECT')"
                  />

                  <memlist-text-input
                    class="mt-4"
                    id="preheader-group"
                    :title="$t('SENDOUT.PREHEADER')"
                    v-model="local_value.preview"
                    :placeholder="$t('SENDOUT.PREHEADER')"
                  />

                </m-col>
              </m-row>
              
              <EmailWithValidDomain
                class="mt-4"
                ref="reply_to"
                title="Reply-to"
                :isRequired="true"
                v-bind:value="local_value.reply_to" v-on:update:email="replyToUpdated"
              />

              <EmailWithValidDomain
                class="mt-4"
                ref="from_email"
                :title="$t('TEMPLATE.FROM_EMAIL')"
                :isRequired="true"
                v-bind:value="local_value.from_email" v-on:update:email="fromEmailUpdated"
              />
            </memlist-card>
            

          </div>
          <div v-else-if="selected_section_name == 'attachments'">
            <memlist-card>
              <h5>{{ $t('TEMPLATE.ATTACHMENTS') }}</h5>

              <input hidden type="file" id="file" ref="file" @change="handle_file_upload" />
              <m-row class="mt-4 mb-4">
                <m-col>
                  <memlist-icon-button
                    class="mb-2"
                    icon="menu-icon flaticon2-plus"
                    :text="$t('TEMPLATE.UPLOAD_ATTACHMENT')"
                    variant="primary"
                    :disabled="!local_value.template_id"
                    @click="select_file"
                  />
                  <p style="font-style: italic; color: #888888;" v-if="!local_value.template_id">{{ $t('TEMPLATE.ATTACHMENT_DISABLED') }}</p>
                </m-col>
              </m-row>

              <m-row v-for="(attachment, index) in attachments" :key="index">
                <m-col lg="12">
                  <memlist-file-upload
                    class="mt-4"
                    :title="$t('PDF_TEMPLATE.IMAGE')"
                    type="image"
                    layout="vertical"
                    v-model="attachment.file_id"

                    @uploaded="file => update_file(index, file.file_id)"
                    @deleted="() => remove_file(index)"
                  />
                </m-col>
              </m-row>


            </memlist-card>
            
          </div>

          <m-row class="mt-4">
            <m-col lg="12">
              <RightModalSaveAndCloseButtons
                :text="$t('COMMON.SAVE')"
                :spin="true"
                :override_spin="override_spin"
                @click="submit_form"
                @close="on_cancel"
                ref="saveButton"
              />

            </m-col>
          </m-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import axios from 'axios';
import swal from 'sweetalert2';
import { upload_file } from '@/core/services/fileUpload';
import { get_domain_url, get_base_url, downloadWithAxios } from '@/core/services/fileDownload';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

import __tags from '@/assets/plugins/email-editor/merge-tags.js';
import EmailWithValidDomain from '@/view/components/EmailWithValidDomain.vue';
import RightModalSaveAndCloseButtons from '@/view/components/buttons/RightModalSaveAndCloseButtons.vue';
import EmailTemplateEditor from '@/view/components/EmailTemplateEditor.vue';
import { is_mobile } from '@/core/services/utils';

export default {
  name: 'TemplateEmailEdit',
  mixins: [ toasts ],
  components: {
    EmailTemplateEditor,
    EmailWithValidDomain,
    RightModalSaveAndCloseButtons,
  },
  props: {
    source: {
      type: String,
      default: null,
    },
    sendout_id: {
      type: Number,
      default: null
    },
    type: {
      type: String
    },
    item: {
      type: Object
    }
  },
  emits: ['updated', 'created', 'cancel'],
  computed: {
    is_mobile() {
      return is_mobile();
    },
    selected_section_name() {
      if (this.selected_item === undefined) {
        return '';
      }

      if (this.unlocked_sections[this.selected_item] === undefined) {
        return '';
      }

      return this.unlocked_sections[this.selected_item].name;
    },
    merge_tags_options() {
      return __tags.map(item => ({ text: item.name, value: `%${item.id}%` }));
    },
    template_public_url() {
      return get_domain_url() + `/template/public/${this.local_value.template_id}/${this.local_value.token}`;
    },
    tabs() {
      let base = [
        { label: 'TEMPLATE.DESIGNER', disabled: false },
        { label: 'TEMPLATE.TEXT', disabled: false },

      ];
      
      return base;
    },
    sendout_template_type_options() {

      const base = [
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.DONATION_NEW_DONATION_RECEIVED'), value: 'DONATION_NEW_DONATION_RECEIVED' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.DONATION_THANK_YOU_SINGLE'), value: 'DONATION_THANK_YOU_SINGLE' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.DONATION_THANK_YOU_RECURRING'), value: 'DONATION_THANK_YOU_RECURRING' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SIMPLE_FORM_ANSWERED'), value: 'SIMPLE_FORM_ANSWERED' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.TICKET_EVENT'), value: 'TICKET_EVENT' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.TICKET_EVENT_ADMIN_NOTIFICATION'), value: 'TICKET_EVENT_ADMIN_NOTIFICATION' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.TODO_UPDATED'), value: 'TODO_UPDATED' },
      ];
      

      if (this.isTHS) {
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SAMFUND_MEMBERS_ERROR_REPORT'), value: 'SAMFUND_MEMBERS_ERROR_REPORT' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.GENERAL_ERROR_REPORT'), value: 'GENERAL_ERROR_REPORT' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.DONATION_NEW_CUSTOMER'), value: 'DONATION_NEW_CUSTOMER' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.DONATION_WELCOME_ADMIN'), value: 'DONATION_WELCOME_ADMIN' });
      }

      if (this.global_settings.type === 'kvitto') {
        
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.EMAIL_NOT_MATCHED'), value: 'EMAIL_NOT_MATCHED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_RECEIVED_AND_FORWARDED'), value: 'KVITTO_RECEIVED_AND_FORWARDED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_ERROR'), value: 'KVITTO_ERROR' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_NO_RULE_MATCHED'), value: 'KVITTO_NO_RULE_MATCHED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_RECEIVED'), value: 'KVITTO_RECEIVED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_MATCHED'), value: 'KVITTO_MATCHED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_NOT_MATCHED'), value: 'KVITTO_NOT_MATCHED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.ACCOUNT_TRANSACTION_NEED_MATCH'), value: 'ACCOUNT_TRANSACTION_NEED_MATCH' });
      }

      if (this.global_settings.type === 'support') {

        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SALES_INFO_MAIL'), value: 'SALES_INFO_MAIL' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SALES_INVITE_MEETING'), value: 'SALES_INVITE_MEETING' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SALES_FOLLOW_UP'), value: 'SALES_FOLLOW_UP' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SALES_SIGN_CONTRACT'), value: 'SALES_SIGN_CONTRACT' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SALES_WELCOME_AFTER_SIGN'), value: 'SALES_WELCOME_AFTER_SIGN' });
      }

      return base;
    },

    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'periods', 'isTHS', 'unlocks', 'customer', 'global_settings']),

    validFromId() {
      return this.validate_from_id();
    },
    fullscreen_visible() {
      const display = this.fullscreen ? 'block' : 'none';
      return `display:${display}`;
    },
    templateDesign() {
      return this.local_value.edit_html;
    },
    creating() {
      return isNaN(parseInt(this.local_value.template_id+''));
    },
    valid_name_state() {
      if (!this.local_value.name) { return false; }
      if (this.local_value.name.length > 0) { return true; }
      return false;
    }
  },
  mounted() {
    
  },
  data() {
    return {
      override_spin: false,
      lastAutoSaveTime: 0,
      autoSaveInterval: 60 * 1000,
      
      selected_item: 1,
      mini: false,
      unlocked_sections: [
        { title: this.$t('TEMPLATE.BASIC'), icon: 'mdi-information-outline', name: 'basic_info', hide_on_create: false },
        { title: this.$t('TEMPLATE.DESIGN'), icon: 'mdi-palette-outline', name: 'designer', hide_on_create: true },
        { title: this.$t('TEMPLATE.ATTACHMENTS'), icon: 'mdi-paperclip', name: 'attachments', hide_on_create: true },
        //{ title: this.$t('TEMPLATE.QUESTIONS'), icon: 'mdi-comment-question', name: 'questions', hide_on_create: true },
        { title: this.$t('TEMPLATE.SENDER'), icon: 'mdi-email', name: 'sender', hide_on_create: true },
      ],

      merge_tag: null,
      attachments: [],
      active_tab: 0,
      sendout_template_type: null,
      instance_id: null,
      instance_options: [],
      local_value: {},
      isValid: true,

      replyToValid: false,
      fromEmailValid: false,
      stickprov: false,
      email: false,
      moving: false,
      templates: [],
      fullscreen: false,
    };
  },

  watch: {
    active_tab() {
      if (this.active_tab === 1) {
        this.cleartextTabClicked();
      }
    },
    item: {
      deep: true,
      handler(new_value, old_value) {
        if (this.item) {
          this.local_value = { ...this.item }

          this.attachments = this.local_value.attachments;

        }

        if (new_value && old_value && new_value.template_id !== old_value.template_id) {
          this.update_editor();
        }

        this.local_value.is_email = true;
      },
      immediate: true
    },

  },
  methods: {
    list_item_group_change() {
      if (is_mobile()) {
        this.mini = true;
      }
    },
    on_drawer_item_click({ index, value, text }) {
      this.selected_item = index
      this.list_item_group_change(index)
    },
    
    on_template_design_saved(design) {
      console.log('design saved');
    },

    async on_template_auto_save(autosave  /*  { edit_html: data, html: val.html } */) {
      
      if (this.local_value.template_id) {
        const now = Date.now();

        if (now - this.lastAutoSaveTime < this.autoSaveInterval) {
          // Skip if less than 1 minute since last save
          return;
        }
        this.override_spin = true;
        this.lastAutoSaveTime = now;
        
        try {
          await axios.put(`/template/${this.local_value.template_id}`, {
            template_id: this.local_value.template_id,
            edit_html: JSON.stringify(JSON.stringify(autosave.edit_html)),
            template: autosave.html
          });
        }
        catch (err) {
          console.error('auto save error', err);
        }
        

        this.override_spin = false;
        //this.toastr('success', this.$t('COMMON.OK'), this.$t('COMMON.AUTOSAVED'));
      }
    },

    on_plaintext_generated(plaintext) {

    },

    goto_url_clicked() {
      window.open(this.template_public_url, '_blank');
    },

    async handle_file_upload() {
      const file = this.$refs.file.files[0];

      if (file.size > (50000000)) {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('PAGES.FILES.MUST_BE_LESS'));
        return;
      }

      try {
        const newfile = await upload_file(file, { file_type: 'PUBLIC_IMAGE', is_public: true });

        const res = await axios.post(`/template/${this.local_value.template_id}/attachment`, { file_id: newfile.file_id });

        if (res.status === 201) {
          this.attachments.push(res.data);
        }
        
        this.toastr('success', this.$t('COMMON.OK'), this.$t('FILE.UPLOADED'));
      }
      catch (err) {
        console.error('handle_file_upload', err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('FILE.UNABLE_UPLOAD'));
      }
      
    },

    select_file() {
      this.$refs.file.value = null;
      this.$refs.file.click();
    },

    async update_file(index, file_id) {
      /*this.local_form.images[index].file_id = file_id;
      this.emit_update();*/
    },

    async remove_file(index) {
      const attachment = this.attachments[index];
      const res = await axios.delete(`/template/attachment/${attachment.id}`);
      
      if (res.status === 204) {
        this.attachments.splice(index, 1);
      }
    },

    on_cancel() {
      this.$emit('cancel');
    },

    async submit_form() {

      await this.save_template();

      this.$refs['saveButton'].stop();
    },

    update_editor() {
      if (this.$refs['emailTemplateEditor']) {
        this.$nextTick(() => {

          if (this.$refs['emailTemplateEditor']) {
            this.$refs['emailTemplateEditor'].force_reload();
          }

        });
      }
    },
    async cleartextTabClicked() {
      if (this.$refs['emailTemplateEditor']) {
        const design_data = await this.$refs['emailTemplateEditor'].exportHTML();

        this.local_value.edit_html = JSON.stringify(JSON.stringify(design_data.edit_html)); // double stringify because of problems
        this.local_value.template = design_data.html;
      }
    },

    replyToUpdated(email) {
      this.local_value.reply_to = email;
    },

    fromEmailUpdated(email) {
      this.local_value.from_email = email;
    },

    copyTemplateToCompany(template_id, company_id) {
      const loader = this.$loading.show();

      axios
        .post(`/template/copy`, { template_id: template_id, company_id: company_id })
        .then(res => {
          loader && loader.hide();
        })
        .catch(err => {
          loader && loader.hide();
          console.error(err);
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_COPY'));
        });
    },

    copyTemplate(template, movable = false) {
      const loader = this.$loading.show();

      if (!movable || template.company_id == this.currentCompanyId) {
        axios
          .post(`/template/copy`, { template_id: template.template_id })
          .then(res => {
            loader && loader.hide();

            this.toastr('success', this.$t('COMMON.OK'), this.$t('TEMPLATE.COPIED'));
          })
          .catch(err => {
            loader && loader.hide();
            console.error(err);
            this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_COPY'));
          });
      } else {
        axios
          .get(`/template/${template.template_id}`)
          .then(res => {
            loader && loader.hide();
            this.local_value = res.data;
            this.attachments = res.data.attachments;
            this.moving = true;

            this.local_value.edit_html = this.local_value.edit_html ? JSON.parse(this.local_value.edit_html) : null;
          })
          .catch(err => {
            loader && loader.hide();
            console.error(err);
            this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_LIST'));
          });
      }
    },
    deleteTemplateClicked(template_id) {
      this.toDelete = template_id;
      this.$refs['deleteTemplateConfirm'].show();
    },
    onDeleteTemplateConfirm() {
      this.deleteTemplate(this.toDelete);
      this.toDelete = null;
    },

    deleteTemplate(template_id) {
      const loader = this.$loading.show();

      axios
        .delete(`/template/${template_id}`)
        .then(res => {
          loader && loader.hide();

          this.toastr('success', this.$t('COMMON.OK'), this.$t('TEMPLATE.DELETED'));
        })
        .catch(err => {
          loader && loader.hide();
          console.error(err);
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_DELETE'));
        });
    },
    changeSystem(template) {
      const loader = this.$loading.show();
      axios
        .put(`/template/${template.template_id}`, template)
        .then(res => {
          loader && loader.hide();
          this.toastr('success', this.$t('COMMON.OK'), this.$t('TEMPLATE.UPDATED'));
        })
        .catch(err => {
          loader && loader.hide();
          console.error(err);
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_UPDATE'));
        });
    },

    async save_template() {
      const loader = this.$loading.show();

      try {
        this.local_value.company_id = this.currentCompanyId;
        this.local_value.type = 'EMAIL';

        if (!this.local_value.from_name) {
          this.local_value.from_name = '';
        }

        // if user forgot to update the plaintext, do it for them
        if (!this.local_value.text || this.local_value.text.length < 2) {
          if (this.$refs['emailTemplateEditor']) {
            this.local_value.text = await this.$refs['emailTemplateEditor'].exportPlainText();
          }
        }

        // if it failed to update the plaintext, set it as subject
        if (!this.local_value.text || this.local_value.text.length < 2) {
          this.local_value.text = this.local_value.subject;
        }

        if (this.$refs['emailTemplateEditor']) {
          const design_data = await this.$refs['emailTemplateEditor'].exportHTML();
          
          this.local_value.edit_html = JSON.stringify(JSON.stringify(design_data.edit_html)); // double stringify because of problems
          this.local_value.template = design_data.html;
          
        }

        if (this.creating) {

          const res = await axios.post('/template', this.local_value);

          if (res.status === 201) {
            this.toastr('success', this.$t('COMMON.OK'), this.$t('TEMPLATE.CREATED'));
            this.local_value.template_id = res.data.template_id;
            this.$emit('created', this.local_value);
          }
          else {
            this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_CREATE'));
          }
        
        } else if (!this.creating) {

          const res = await axios.put(`/template/${this.local_value.template_id}`, this.local_value);

          if (res.status === 204) {
            this.toastr('success', this.$t('COMMON.OK'), this.$t('TEMPLATE.UPDATED'));
            this.$emit('updated', this.local_value);
          }
          else {
            this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_UPDATE'));
          }
        }
      }
      catch (err) {
        console.error('error saving template', err);
      }
      
      loader && loader.hide();
    },
    async export_pdf_clicked() {
      console.log(await this.$refs['emailTemplateEditor'].export_pdf());
    },
    async exportPlaintextClicked() {
      // will emit 'plaintext'
      if (this.$refs['emailTemplateEditor']) {
        this.local_value.text = await this.$refs['emailTemplateEditor'].exportPlainText();
      }
      
    },

    backToSendout() {
      this.$router.push(`/ml-sendout/${this.sendout_id}`);
    },
    setTemplateProps() {
      const sendout_id = parseInt(this.$route.params.sendout_id);
      const id = this.$route.params.template_id;
      const editing = Boolean(parseInt(this.$route.params.is_edit));

      if (!isNaN(sendout_id)) {
        this.local_value.template_id = editing ? id : '';
        this.sendout_id = sendout_id;
      }
    },
    moveToCompanies() {
      const company_ids = this.$refs['companies_selected'].getCompanies();

      for (const cid of company_ids) {
        this.copyTemplateToCompany(this.local_value.template_id, cid);
      }

      this.toastr('success', this.$t('COMMON.OK'), this.$t('TEMPLATE.COPIED'));
    }
  }
};
</script>

<style lang="scss" scoped>


.modal-xl {
  max-width: 100% !important;
  padding-right: 17px;
}

:deep .dark-modal {
  color: white;
  background-color: #293039;
  border-bottom: 1px solid #444c56;
}

:deep .dark-modal-body {
  color: white;
  background-color: #293039;
}

.ml-url-link:hover {
  cursor: pointer;
}

.row {
  margin-top: -12px !important;
}

.page-container {
  height: 100%;
  display: flex;
  flex-flow: column;
}

.fill-rest {
  flex: 1 1 auto;
}


.quick-search-card {
  overflow: scroll;
}

.selected-item-active {
  border-radius: 4px;
  background: #f4fcff;
  color: black;
}

.card-title {
  background-color:#f7f7f7;
  border-bottom:1px solid #dedede;
  padding-bottom: 15px;

}

.card-title-p {
  margin-bottom: 8px !important;
  margin-top: 7px !important;
}


.top-container {
  display: flex;
}

.content {
  flex-grow: 1;
  margin-top: 0px !important;
  padding-top: 0px !important;
  margin-left: 8px !important;
}



.drawer-header {
  margin-bottom: -13px !important;
}

.drawer {
  border-right: 1px solid #dddddd !important;
}

.fixed-font {
  font-size: 0.95rem !important;
  font-weight: 500;
  line-height: 1rem;
}

:deep .v-application--wrap {
  min-height: 0px !important;
}

.ml-url-link:hover {
  cursor: pointer;
}

</style>

